import { useMemo } from 'react';

import { TaxonomyType } from '@revelio/data-access';

import { useReferenceTaxonomyVersions } from '../selection-lists/hooks/useReferenceTaxonomyVersions';
import { BaseTaxonomyIdSelect } from './BaseTaxonomyIdSelect';

type ActivityTaxonomyIdSelectProps = {
  isDisabled?: boolean;
  currentResolvedAdaptiveLabel?: string;
  variant?: 'default' | 'compact';
  usePortal?: boolean;
  selectedLabelPrefix?: string;
  value?: number | 'adaptive';
  onChange: (taxonomyId: number | 'adaptive') => void;
};

export const ActivityTaxonomyIdSelect = ({
  value,
  onChange,
  isDisabled = false,
  currentResolvedAdaptiveLabel,
  variant = 'default',
  usePortal = false,
  selectedLabelPrefix,
}: ActivityTaxonomyIdSelectProps) => {
  const { taxonomies } = useReferenceTaxonomyVersions({
    taxonomyType: TaxonomyType.Activity,
  });

  const taxonomyIds = useMemo(() => {
    if (!taxonomies || taxonomies.length === 0) return undefined;

    return taxonomies.filter((t) => t.is_latest).map((t) => t.id);
  }, [taxonomies]);

  return (
    <BaseTaxonomyIdSelect
      includeAdaptive
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
      currentResolvedAdaptiveLabel={currentResolvedAdaptiveLabel}
      variant={variant}
      usePortal={usePortal}
      taxonomyIds={taxonomyIds}
      selectedLabelPrefix={selectedLabelPrefix}
    />
  );
};
